enum TimeEntryModalSourceType {
  TimeEntry = 1,
  TimeStamp = 2,
}

export default TimeEntryModalSourceType
